import React from 'react';
import classNames from 'classnames';
import { Checkbox, Icon } from 'Permafrost/index';
import { StyledFilterSelectOptions } from './FilterSelectOptions.styles';
export const FilterSelectOptions = ({ isMulti, optionsList, selectedFilters, handleOptionClick, }) => {
    return (React.createElement(StyledFilterSelectOptions, null, optionsList === null || optionsList === void 0 ? void 0 : optionsList.map((filterOption) => {
        const { text, value, iconName } = filterOption;
        const selected = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some((item) => item.value === value);
        return (React.createElement("li", { key: `LabelFilter-${value}`, "data-testid": `li--filter-list-${value}`, className: classNames('option-container', {
                selected,
            }), onClick: () => {
                handleOptionClick(filterOption);
            } }, isMulti ? (React.createElement("div", { className: "multi-option" },
            React.createElement(Checkbox, { "aria-label": `Checkbox option ${filterOption.value}`, className: "option-checkbox", isSelected: selected }),
            text)) : (React.createElement("div", { className: "single-option" },
            text,
            iconName ? (React.createElement(Icon, { name: iconName, className: "filter__icon", "data-testid": `li--filter-list-icon-for-${value}` })) : null,
            selected ? (React.createElement(Icon, { name: "check", className: "selected-checkmark", "data-testid": `li--filter-list-icon-selected-indicator-for-${value}` })) : null))));
    })));
};
//# sourceMappingURL=FilterSelectOptions.js.map